'use strict';

exports.__esModule = true;

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      scrollbarWidthCalcNode = _ref.scrollbarWidthCalcNode;

  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined && !scrollbarWidthCalcNode) return scrollBarWidth;
  if (customScrollBarWidth > 0 && scrollbarWidthCalcNode) return customScrollBarWidth;

  var customNode = scrollbarWidthCalcNode && document.querySelector(scrollbarWidthCalcNode);

  var target = customNode || document.body;

  var outer = document.createElement('div');
  outer.className = 'wd-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  target.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;
  // 自定义节点可以获取到时
  if (customNode) {
    customScrollBarWidth = widthNoScroll - widthWithScroll;
    return customScrollBarWidth;
  }
  return scrollBarWidth;
};

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollBarWidth = void 0;
var customScrollBarWidth = void 0; // 自定义滚动条宽度

;